import { render, staticRenderFns } from "./AddSlideShow.vue?vue&type=template&id=32220f9e&scoped=true"
import script from "./AddSlideShow.vue?vue&type=script&lang=js"
export * from "./AddSlideShow.vue?vue&type=script&lang=js"
import style0 from "./AddSlideShow.vue?vue&type=style&index=0&id=32220f9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32220f9e",
  null
  
)

export default component.exports